import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import SessionTimeoutNotifier from '../components/SessionTimeoutNotifier';

const SessionTimeoutNotifierBridge = react2angular(SessionTimeoutNotifier);
export default SessionTimeoutNotifierBridge;
